<template>
  <div>
    <h1>backup</h1>
  </div>
</template>
<script>
import moment from "moment";
import firebase from "firebase";
const db = firebase.firestore();
export default {
  data() {
    return {
      todaydate: "",
      yesterdaydate: "",

      totaluserlist: [],
      yesterdayuser: [],
      todayuser: [],
      totalgame: [],
      yesterdaygame: [],
      todaygame: [],
      totaltoken: "",
      totalNFT: "",

      ragecount: "",
      maticount: "",
      Razorcount: "",
      Drakoincount: "",
      CryptoPuzzles: "",
      IndependenceDay: "",
      RageFan_GenShards: "",
      circuit_city: "",
      FinEuro: "",
      AxiInfinite: "",
      ragearray: [],
      matiarray: [],
      razorarray: [],
      drakoinarray: [],
      CryptoPuzzlesarray: [],
      IndependenceDayarray: [],
      RageFan_GenShardsarray: [],
      circuit_cityarray: [],
      FinEuroarray: [],
      AxiInfinitearray: [],

      ragecounttoday: "",
      maticounttoday: "",
      Razorcounttoday: "",
      Drakoincounttoday: "",
      CryptoPuzzlestoday: "",
      IndependenceDaytoday: "",
      RageFan_GenShardstoday: "",
      circuit_citytoday: "",
      FinEurotoday: "",
      AxiInfinitetoday: "",
      ragearraytoday: [],
      matiarraytoday: [],
      razorarraytoday: [],
      drakoinarraytoday: [],
      CryptoPuzzlesarraytoday: [],
      IndependenceDayarraytoday: [],
      RageFan_GenShardsarraytoday: [],
      circuit_cityarraytoday: [],
      FinEuroarraytoday: [],
      AxiInfinitearraytoday: [],

      yesterdaytoken: 0,
      todaytoken: 0,
      yesterdayNFT: 0,
      todayNFT: 0,

      yesterdaycapture: [],
      todaycapture: [],

      ragelength: 0,
      maticlenth: 0,
      Razorlenth: 0,
      Drakoinlength: 0,
      CryptoPuzzleslength: 0,

      IndependenceDaylength: 0,
      RageFan_GenShardslength: 0,
      circuit_citylength: 0,
      FinEurotoday: 0,
      AxiInfinitetoday: 0,

      ragecountlength: 0,
      maticountlength: 0,
      Razorcountlength: 0,
      Drakoincountlength: 0,
      CryptoPuzzlescountlength: 0,

      IndependenceDaycountlength: 0,
      RageFan_GenShardscountlength: 0,
      circuit_citycountlength: 0,
      FinEurocountlenght: 0,
      AxiInfinitecountlength: 0,

      yesterdayTotaltoken: 0,
      yesterdayTotalnft: 0,
      ragedata: [],
      ragedatatoday: [],

      yesterdayusernft: [],
      yesterdayusertoken: [],

      todayusernft: [],
      todayusertoken: [],

      yestercaptureNFT: "",
      yestercaptureToken: "",
      TodaycaptureNFT: "",
      TodaycaptureToken: "",

      todayuserlist: [],
      yesterdayuserlist: [],

      totalusercount: "",
      todayusercount: "",
      yesterdayusercount: "",

      totalgamecount: "",
      todaygamecount: "",
      yesterdaygamecount: "",
    };
  },
  mounted: function () {
    // this.getuser();
    // this.checkdate();
    // this.gamepoint();
    // this.gettokens();
    // this.update();
    window.setInterval(() => {
      this.getuser();
      this.checkdate();
      this.gamepoint();
      this.gettokens();
      this.update();
    }, 10000);
  },
  methods: {
    getuser() {
      // this.totaluserlist = [];
      db.collection("users")
        .get()
        .then((snapshot) => {
          this.totaluserlist = [];
          snapshot.forEach((doc) => {
            this.totaluserlist.push({
              Id: doc.id,
            });
          });
          this.totalusercount = this.totaluserlist.length;
          console.log("this.totaluserlist", this.totalusercount);
        });
    },
    checkdate() {
      let today = new Date();
      let yesterday = new Date();

      yesterday.setDate(today.getDate() - 1);

      let v1 = moment(today).format("DD-MMM-YYYY");
      // console.log("Today: " + v1);
      let v2 = moment(yesterday).format("DD-MMM-YYYY");
      // console.log("yesterday: " + v2);
      this.todayuserlist = [];
      this.yesterdayuserlist = [];
      db.collection("users")
        .where("created", "!=", null)

        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            let backenddate = moment(doc.data().created.seconds * 1000).format(
              "DD-MMM-YYYY"
            );

            if (backenddate == v1) {
              this.todayuserlist.push({
                id: doc.id,
              });
            }
            this.todayusercount = this.todayuserlist.length;
            if (backenddate == v2) {
              this.yesterdayuserlist.push({
                id: doc.id,
              });
            }
            this.yesterdayusercount = this.yesterdayuserlist.length;
          });
        });

      //  this.totalusercount= this.totaluserlist.length;

      // console.log("this.totaluserlist.length", this.totaluserlist.length);
      // console.log("this.todayuserlist.length", this.todayuserlist.length);
      // console.log(
      //   "this.yesterdayuserlist.length",
      //   this.yesterdayuserlist.length
      // );
    },
    gamepoint() {
      this.totalgame = [];
      this.todaygame = [];
      this.yesterdaygame = [];
      let today = new Date();
      let yesterday = new Date();

      yesterday.setDate(today.getDate() - 1);

      let v1 = moment(today).format("DD-MMM-YYYY");
      let v2 = moment(yesterday).format("DD-MMM-YYYY");
      db.collection("snakeLimitEntry")
        .where("date", "!=", null)

        .get()
        .then((snapshot) => {
          this.totalgame = [];
          this.todaygame = [];
          this.yesterdaygame = [];
          snapshot.forEach((doc) => {
            this.totalgame.push({
              id: doc.id,
            });

            let backenddate = moment(
              doc.data().dateObject.seconds * 1000
            ).format("DD-MMM-YYYY");

            if (backenddate == v1) {
              this.todaygame.push({
                id: doc.id,
              });
            }

            if (backenddate == v2) {
              this.yesterdaygame.push({
                id: doc.id,
              });
            }
          });
          this.totalgamecount = this.totalgame.length;
          this.todaygamecount = this.todaygame.length;
          this.yesterdaygamecount = this.yesterdaygame.length;
        });
    },

    gettokens() {
      this.yesterdaycapture = [];
      this.ragearray = [];
      this.matiarray = [];
      this.razorarray = [];
      this.drakoinarray = [];
      this.CryptoPuzzlesarray = [];
      this.IndependenceDayarray = [];
      this.RageFan_GenShardsarray = [];
      this.circuit_cityarray = [];
      this.FinEuroarray = [];
      this.AxiInfinitearray = [];
      this.todaycapture = [];
      this.ragearraytoday = [];
      this.matiarraytoday = [];
      this.razorarraytoday = [];
      this.drakoinarraytoday = [];
      this.CryptoPuzzlesarraytoday = [];
      this.IndependenceDayarraytoday = [];
      this.RageFan_GenShardsarraytoday = [];
      this.circuit_cityarraytoday = [];
      this.FinEuroarraytoday = [];
      this.AxiInfinitearraytoday = [];
      (this.ragedata = []),
        (this.ragedatatoday = []),
        (this.yesterdayusernft = []),
        (this.yesterdayusertoken = []),
        (this.todayusernft = []),
        (this.todayusertoken = []);
      const db = firebase.firestore();
      db.collection("companyDetails2")
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            // if (doc.data().NFT==false) {
            //   this.totaltoken.push({
            //     id: doc.id,
            //   });
            // }else{
            //      this.totalNFT.push({
            //     id: doc.id,
            //   });
            // }
          });
          // console.log("this.totalNFT: " + this.totalNFT.length);
        });

      let today = new Date();
      let yesterday = new Date();

      yesterday.setDate(today.getDate() - 1);

      let v1 = moment(today).format("DD-MMM-YYYY");
      let v2 = moment(yesterday).format("DD-MMM-YYYY");

      db.collection("dateWiseRecord")
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            for (let i in doc.data()) {
              let backenddate = moment(
                doc.data()[i].Date.seconds * 1000
              ).format("DD-MMM-YYYY");

              if (backenddate == v1) {
                this.ragedatatoday.push({
                  id: doc.id,
                  Ragecount:
                    doc.data()[i].Rage != undefined
                      ? doc.data()[i].Rage.count
                      : 0,
                  Maticcount:
                    doc.data()[i].Matic != undefined
                      ? doc.data()[i].Matic.count
                      : 0,
                  Razorcount:
                    doc.data()[i].Razor != undefined
                      ? doc.data()[i].Razor.count
                      : 0,
                  Drakoincount:
                    doc.data()[i].Drakoin != undefined
                      ? doc.data()[i].Drakoin.count
                      : 0,
                  CryptoPuzzles:
                    doc.data()[i]["Crypto Puzzles"] != undefined
                      ? doc.data()[i]["Crypto Puzzles"].count
                      : 0,
                  IndependenceDay:
                    doc.data()[i]["75th Indian Independence Day Edition"] !=
                    undefined
                      ? doc.data()[i]["75th Indian Independence Day Edition"]
                          .count
                      : 0,
                  RageFan_GenShards:
                    doc.data()[i]["RageFan+GenShards Partnership NFT"] !=
                    undefined
                      ? doc.data()[i]["RageFan+GenShards Partnership NFT"].count
                      : 0,
                  circuit_city:
                    doc.data()[i]["circuit city"] != undefined
                      ? doc.data()[i]["circuit city"].count
                      : 0,
                  FinEuro:
                    doc.data()[i]["FinEuro"] != undefined
                      ? doc.data()[i]["FinEuro"].count
                      : 0,
                  AxiInfinite:
                    doc.data()[i]["Axi Infinite"] != undefined
                      ? doc.data()[i]["Axi Infinite"].count
                      : 0,
                });
                this.todaycapture.push(doc.id);
                this.ragearraytoday.push(
                  doc.data()[i].Rage != undefined ? doc.data()[i].Rage.count : 0
                );
                this.matiarraytoday.push(
                  doc.data()[i].Matic != undefined
                    ? doc.data()[i].Matic.count
                    : 0
                );
                this.razorarraytoday.push(
                  doc.data()[i].Razor != undefined
                    ? doc.data()[i].Razor.count
                    : 0
                );
                this.drakoinarraytoday.push(
                  doc.data()[i].Drakoin != undefined
                    ? doc.data()[i].Drakoin.count
                    : 0
                );
                this.CryptoPuzzlesarraytoday.push(
                  doc.data()[i]["Crypto Puzzles"] != undefined
                    ? doc.data()[i]["Crypto Puzzles"].count
                    : 0
                );

                //NFT
                this.IndependenceDayarraytoday.push(
                  doc.data()[i]["75th Indian Independence Day Edition"] !=
                    undefined
                    ? doc.data()[i]["75th Indian Independence Day Edition"]
                        .count
                    : 0
                );

                this.RageFan_GenShardsarraytoday.push(
                  doc.data()[i]["RageFan+GenShards Partnership NFT"] !=
                    undefined
                    ? doc.data()[i]["RageFan+GenShards Partnership NFT"].count
                    : 0
                );

                this.circuit_cityarraytoday.push(
                  doc.data()[i]["circuit city"] != undefined
                    ? doc.data()[i]["circuit city"].count
                    : 0
                );

                this.FinEuroarraytoday.push(
                  doc.data()[i]["FinEuro"] != undefined
                    ? doc.data()[i]["FinEuro"].count
                    : 0
                );

                this.AxiInfinitearraytoday.push(
                  doc.data()[i]["Axi Infinite"] != undefined
                    ? doc.data()[i]["Axi Infinite"].count
                    : 0
                );

                this.ragecounttoday = this.ragearraytoday.reduce(function (
                  a,
                  b
                ) {
                  return a + b;
                },
                0);

                this.maticounttoday = this.matiarraytoday.reduce(function (
                  a,
                  b
                ) {
                  return a + b;
                },
                0);

                this.Razorcounttoday = this.razorarraytoday.reduce(function (
                  a,
                  b
                ) {
                  return a + b;
                },
                0);

                this.Drakoincounttoday = this.drakoinarraytoday.reduce(
                  function (a, b) {
                    return a + b;
                  },
                  0
                );

                this.CryptoPuzzlestoday = this.CryptoPuzzlesarraytoday.reduce(
                  function (a, b) {
                    return a + b;
                  },
                  0
                );

                //NFT

                this.IndependenceDaytoday =
                  this.IndependenceDayarraytoday.reduce(function (a, b) {
                    return a + b;
                  }, 0);

                this.RageFan_GenShardstoday =
                  this.RageFan_GenShardsarraytoday.reduce(function (a, b) {
                    return a + b;
                  }, 0);

                this.circuit_citytoday = this.circuit_cityarraytoday.reduce(
                  function (a, b) {
                    return a + b;
                  },
                  0
                );

                this.FinEurotoday = this.FinEuroarraytoday.reduce(function (
                  a,
                  b
                ) {
                  return a + b;
                },
                0);

                this.AxiInfinitetoday = this.AxiInfinitearraytoday.reduce(
                  function (a, b) {
                    return a + b;
                  },
                  0
                );
              }

              if (backenddate == v2) {
                this.ragedata.push({
                  id: doc.id,
                  Ragecount:
                    doc.data()[i].Rage != undefined
                      ? doc.data()[i].Rage.count
                      : 0,
                  Maticcount:
                    doc.data()[i].Matic != undefined
                      ? doc.data()[i].Matic.count
                      : 0,
                  Razorcount:
                    doc.data()[i].Razor != undefined
                      ? doc.data()[i].Razor.count
                      : 0,
                  Drakoincount:
                    doc.data()[i].Drakoin != undefined
                      ? doc.data()[i].Drakoin.count
                      : 0,
                  CryptoPuzzles:
                    doc.data()[i]["Crypto Puzzles"] != undefined
                      ? doc.data()[i]["Crypto Puzzles"].count
                      : 0,
                  IndependenceDay:
                    doc.data()[i]["75th Indian Independence Day Edition"] !=
                    undefined
                      ? doc.data()[i]["75th Indian Independence Day Edition"]
                          .count
                      : 0,
                  RageFan_GenShards:
                    doc.data()[i]["RageFan+GenShards Partnership NFT"] !=
                    undefined
                      ? doc.data()[i]["RageFan+GenShards Partnership NFT"].count
                      : 0,
                  circuit_city:
                    doc.data()[i]["circuit city"] != undefined
                      ? doc.data()[i]["circuit city"].count
                      : 0,
                  FinEuro:
                    doc.data()[i]["FinEuro"] != undefined
                      ? doc.data()[i]["FinEuro"].count
                      : 0,
                  AxiInfinite:
                    doc.data()[i]["Axi Infinite"] != undefined
                      ? doc.data()[i]["Axi Infinite"].count
                      : 0,
                });
                this.yesterdaycapture.push(doc.id);
                this.ragearray.push(
                  doc.data()[i].Rage != undefined ? doc.data()[i].Rage.count : 0
                );
                this.matiarray.push(
                  doc.data()[i].Matic != undefined
                    ? doc.data()[i].Matic.count
                    : 0
                );
                this.razorarray.push(
                  doc.data()[i].Razor != undefined
                    ? doc.data()[i].Razor.count
                    : 0
                );
                this.drakoinarray.push(
                  doc.data()[i].Drakoin != undefined
                    ? doc.data()[i].Drakoin.count
                    : 0
                );
                this.CryptoPuzzlesarray.push(
                  doc.data()[i]["Crypto Puzzles"] != undefined
                    ? doc.data()[i]["Crypto Puzzles"].count
                    : 0
                );

                //NFT
                this.IndependenceDayarray.push(
                  doc.data()[i]["75th Indian Independence Day Edition"] !=
                    undefined
                    ? doc.data()[i]["75th Indian Independence Day Edition"]
                        .count
                    : 0
                );

                this.RageFan_GenShardsarray.push(
                  doc.data()[i]["RageFan+GenShards Partnership NFT"] !=
                    undefined
                    ? doc.data()[i]["RageFan+GenShards Partnership NFT"].count
                    : 0
                );

                this.circuit_cityarray.push(
                  doc.data()[i]["circuit city"] != undefined
                    ? doc.data()[i]["circuit city"].count
                    : 0
                );

                this.FinEuroarray.push(
                  doc.data()[i]["FinEuro"] != undefined
                    ? doc.data()[i]["FinEuro"].count
                    : 0
                );

                this.AxiInfinitearray.push(
                  doc.data()[i]["Axi Infinite"] != undefined
                    ? doc.data()[i]["Axi Infinite"].count
                    : 0
                );

                this.ragecount = this.ragearray.reduce(function (a, b) {
                  return a + b;
                }, 0);

                this.maticount = this.matiarray.reduce(function (a, b) {
                  return a + b;
                }, 0);

                this.Razorcount = this.razorarray.reduce(function (a, b) {
                  return a + b;
                }, 0);

                this.Drakoincount = this.drakoinarray.reduce(function (a, b) {
                  return a + b;
                }, 0);

                this.CryptoPuzzles = this.CryptoPuzzlesarray.reduce(function (
                  a,
                  b
                ) {
                  return a + b;
                },
                0);

                //NFT

                this.IndependenceDay = this.IndependenceDayarray.reduce(
                  function (a, b) {
                    return a + b;
                  },
                  0
                );

                this.RageFan_GenShards = this.RageFan_GenShardsarray.reduce(
                  function (a, b) {
                    return a + b;
                  },
                  0
                );

                this.circuit_city = this.circuit_cityarray.reduce(function (
                  a,
                  b
                ) {
                  return a + b;
                },
                0);

                this.FinEuro = this.FinEuroarray.reduce(function (a, b) {
                  return a + b;
                }, 0);

                this.AxiInfinite = this.AxiInfinitearray.reduce(function (
                  a,
                  b
                ) {
                  return a + b;
                },
                0);
              }
            }
          });

          for (let i = 0; i < this.ragedata.length; i++) {
            if (
              this.ragedata[i].AxiInfinite > 0 ||
              this.ragedata[i].FinEuro > 0 ||
              this.ragedata[i].IndependenceDay > 0 ||
              this.ragedata[i].RageFan_GenShards > 0 ||
              this.ragedata[i].circuit_city > 0
            ) {
              this.yesterdayusernft.push(this.ragedata[i].id);
            } else if (
              this.ragedata[i].Ragecount > 0 ||
              this.ragedata[i].Maticcount > 0 ||
              this.ragedata[i].Razorcount > 0 ||
              this.ragedata[i].Drakoincount > 0 ||
              this.ragedata[i].CryptoPuzzles > 0
            ) {
              this.yesterdayusertoken.push(this.ragedata[i].id);
            }
          }

          for (let i = 0; i < this.ragedatatoday.length; i++) {
            if (
              this.ragedatatoday[i].AxiInfinite > 0 ||
              this.ragedatatoday[i].FinEuro > 0 ||
              this.ragedatatoday[i].IndependenceDay > 0 ||
              this.ragedatatoday[i].RageFan_GenShards > 0 ||
              this.ragedatatoday[i].circuit_city > 0
            ) {
              this.todayusernft.push(this.ragedatatoday[i].id);
            } else if (
              this.ragedatatoday[i].Ragecount > 0 ||
              this.ragedatatoday[i].Maticcount > 0 ||
              this.ragedatatoday[i].Razorcount > 0 ||
              this.ragedatatoday[i].Drakoincount > 0 ||
              this.ragedatatoday[i].CryptoPuzzles > 0
            ) {
              this.todayusertoken.push(this.ragedatatoday[i].id);
            }
          }

          this.yestercaptureNFT = this.yesterdayusernft.length;
          this.yestercaptureToken = this.yesterdayusertoken.length;
          this.TodaycaptureNFT = this.todayusernft.length;
          this.TodaycaptureToken = this.todayusertoken.length;
          // console.log(
          //   " this.yesterdayusernft-backup",
          //   this.yesterdayusernft.length
          // );
          // console.log(
          //   "this.yesterdayusertoken-backup",
          //   this.yesterdayusertoken.length
          // );
          // console.log(" this.todayusernft-backup", this.todayusernft.length);
          // console.log("this.todayusertoken-backup", this.todayusertoken.length);

          this.todaytoken =
            this.ragecounttoday +
            this.maticounttoday +
            this.Razorcounttoday +
            this.Drakoincounttoday +
            this.CryptoPuzzlestoday;
          this.yesterdaytoken =
            this.ragecount +
            this.maticount +
            this.Razorcount +
            this.Drakoincount +
            this.CryptoPuzzles;
          this.todayNFT =
            this.IndependenceDaytoday +
            this.RageFan_GenShardstoday +
            this.circuit_citytoday +
            this.FinEurotoday +
            this.AxiInfinitetoday;
          this.yesterdayNFT =
            this.IndependenceDay +
            this.RageFan_GenShards +
            this.circuit_city +
            this.FinEuro +
            this.AxiInfinite;

          if (this.ragecounttoday > 0) {
            this.ragelength = 1;
          }
          if (this.maticounttoday > 0) {
            this.maticlenth = 1;
          }
          if (this.Razorcounttoday > 0) {
            this.Razorlenth = 1;
          }
          if (this.Drakoincounttoday > 0) {
            this.Drakoinlength = 1;
          }
          if (this.CryptoPuzzlestoday > 0) {
            this.CryptoPuzzleslength = 1;
          }

          this.totaltoken =
            this.ragelength +
            this.maticlenth +
            this.Razorlenth +
            this.Drakoinlength +
            this.CryptoPuzzleslength;

          if (this.ragecount > 0) {
            this.ragecountlength = 1;
          }

          if (this.maticount > 0) {
            this.maticountlength = 1;
          }

          if (this.Razorcount > 0) {
            this.Razorcountlength = 1;
          }

          if (this.Drakoincount > 0) {
            this.Drakoincountlength = 1;
          }

          if (this.CryptoPuzzles > 0) {
            this.CryptoPuzzlescountlength = 1;
          }

          this.yesterdayTotaltoken =
            this.ragecountlength +
            this.maticountlength +
            this.Razorcountlength +
            this.Drakoincountlength +
            this.CryptoPuzzlescountlength;

          // console.log("this.yesterdayTotaltoken", this.yesterdayTotaltoken);

          if (this.IndependenceDaytoday > 0) {
            this.IndependenceDaylength = 1;
          }
          if (this.RageFan_GenShardstoday > 0) {
            this.RageFan_GenShardslength = 1;
          }
          if (this.circuit_citytoday > 0) {
            this.circuit_citylength = 1;
          }
          if (this.FinEurotoday > 0) {
            this.FinEurotoday = 1;
          }
          if (this.AxiInfinitetoday > 0) {
            this.AxiInfinitetoday = 1;
          }

          this.totalNFT =
            this.IndependenceDaylength +
            this.RageFan_GenShardslength +
            this.circuit_citylength +
            this.FinEurotoday +
            this.AxiInfinitetoday;
        });

      if (this.IndependenceDay > 0) {
        this.IndependenceDaycountlength = 1;
      }
      if (this.RageFan_GenShards > 0) {
        this.RageFan_GenShardscountlength = 1;
      }
      if (this.circuit_city > 0) {
        this.circuit_citycountlength = 1;
      }

      if (this.FinEuro > 0) {
        this.FinEurocountlenght = 1;
      }

      if (this.AxiInfinite > 0) {
        this.AxiInfinitecountlength = 1;
      }

      this.yesterdayTotalnft =
        this.IndependenceDaycountlength +
        this.RageFan_GenShardscountlength +
        this.circuit_citycountlength +
        this.FinEurocountlenght +
        this.AxiInfinitecountlength;

      // console.log("this.yesterdayTotalnft",this.yesterdayTotalnft)
      let tokenDetails = {
        TodayToken: this.todaytoken,
        yesterdayToken: this.yesterdaytoken,
        TodayNFT: this.todayNFT,
        YesterdayNFT: this.yesterdayNFT,
        TodaytotalToken: this.totaltoken,
        TodaytotalNFT: this.totalNFT,
        yesterdayTotalnft: this.yesterdayTotalnft,
        yesterdayTotaltoken: this.yesterdayTotaltoken,
        yestercaptureNFT: this.yestercaptureNFT,
        yestercaptureToken: this.yestercaptureToken,
        TodaycaptureNFT: this.TodaycaptureNFT,
        TodaycaptureToken: this.TodaycaptureToken,
        totalusercount: this.totalusercount,
        todayusercount: this.todayusercount,
        yesterdayusercount: this.yesterdayusercount,
        totalgamecount: this.totalgamecount,
        todaygamecount: this.todaygamecount,
        yesterdaygamecount: this.yesterdaygamecount,
      };

      localStorage.setItem("tokenDetails", JSON.stringify(tokenDetails));
    },
    update() {
      let tokenDetails = JSON.parse(localStorage.getItem("tokenDetails"));

      console.log("tokenDetails", tokenDetails);
    },
  },

  created() {},
};
</script>